import React, { useState, SetStateAction, useEffect } from 'react';
import { Grid, Typography, Box, InputLabel } from '@material-ui/core';
import { useStyles } from './styles';
import { Refusa } from '../../@types/records';
import SubInputWarn from '../SubInputWarn';

interface IProps {
  refusalAmount: Refusa;
  setRefusalAmount: React.Dispatch<SetStateAction<Refusa>>;
  formErrors: { key: string; message: string }[];
}

const RefusalFormGroup: React.FC<IProps> = ({
  refusalAmount,
  setRefusalAmount,
  formErrors,
}) => {
  const classes = useStyles();
  const [refusalState, setRefusalState] = useState<Refusa>(refusalAmount);
  const [errors, setErrors] = useState<{ key: string; message: string }[]>([]);

  const handleChange = (key: string, value: string) => {
    setRefusalState({ ...refusalAmount, [key]: value });
  };

  useEffect(() => {
    setRefusalState(refusalAmount);
    const testsErrors = formErrors.filter((item) => {
      return item.key === 'testsRefusal';
    });

    setErrors(testsErrors);
  }, [formErrors, refusalAmount]);

  return (
    <Box className={classes.sectionContainer}>
      <Typography variant="h6">Total de Recusas</Typography>
      <Grid container xl={12} spacing={2}>
        <Grid item md={6} sm={12} xs={12}>
          <InputLabel className={classes.label} error={!!errors.length}>
            Testes recusados por homens
          </InputLabel>
          <input
            name="Total de Recusas Masculino"
            type="number"
            min={0}
            className={`${classes.input} ${errors.length ? classes.errorIput : ''}`}
            value={refusalState['Total de Recusas Masculino']}
            onChange={(event) => {
              handleChange('Total de Recusas Masculino', event.target.value);
            }}
            onBlur={() => setRefusalAmount(refusalState)}
          />
          <SubInputWarn
            type="error"
            formWarns={errors.filter((item) => item.key === 'testsRefusal')}
          />
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
          <InputLabel className={classes.label} error={!!errors.length}>
            Testes recusados por mulheres
          </InputLabel>
          <input
            name="Total de Recusas Feminino"
            type="number"
            min={0}
            className={classes.input}
            value={refusalState['Total de Recusas Feminino']}
            onChange={(event) => {
              handleChange('Total de Recusas Feminino', event.target.value);
            }}
            onBlur={() => setRefusalAmount(refusalState)}
          />
          <SubInputWarn
            type="error"
            formWarns={errors.filter((item) => item.key === 'testsRefusal')}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default RefusalFormGroup;
